import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card} from 'antd'
import {TextField,DatePickerField , SelectField} from 'redux-form-antd'
import {
    nullValue1,
    required,
    person_id
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 },
    },
};
const StudentData = props => {
    const stud_sex = [
        {
            label: '-- 請選擇 --',
            value: "-1"
        },
        {
            label: '男',
            value: "1"
        },
        {

            label: '女',
            value: "2"
        }
    ]
    return (
        <Card title="學生基本資料">
            <Field {...formItemLayout} validate={[required]} component={TextField} label="中文姓名"
                   name="stud_name" type="text" disabled={true}></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="英文姓名"
                   name="stud_country_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="護照名"
                   name="stud_name_eng" type="text"></Field>
            <Field {...formItemLayout} component={DatePickerField} label="出生年月日"
                   name="stud_birthday" disabled={true}></Field>
            <Field {...formItemLayout} validate={[required, person_id]} component={TextField} label="身分證字號"
                   name="stud_person_id" type="text" disabled={true}></Field>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="性別"
                   options={stud_sex} name="stud_sex" disabled={true}></Field>
            <Field  {...formItemLayout} validate={[required]} component={TextField} label="戶籍地址"
                   name="stud_addr_1" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="通訊地址"
                   name="stud_addr_2" type="text"></Field>
        </Card>
    )
}
export default StudentData


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentData.jsx